import { render, staticRenderFns } from "./AccordionAlerts.vue?vue&type=template&id=68b2e56d"
import script from "./AccordionAlerts.vue?vue&type=script&lang=js"
export * from "./AccordionAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports